export enum ManagerReviewAccessState {
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED',
  SHARED = 'SHARED'
}
